import { Injectable } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from "rxjs/operators";
import { DataTransferService } from '../services/data.transfer.service';

@Injectable({
  providedIn: 'root'
})
export class StoreService {

  constructor(
    private apiService: ApiService,
    private dataTransferService: DataTransferService
  ) { }
  resolve(): Observable<any> {
    return this.apiService.getStoreDetails()
      .pipe(
        map((result) => {
          const storeId = result['response']['data']['store']['id']
          if (storeId) {
            this.dataTransferService.setStoreId(storeId)
          }
          return result;
        }),
        catchError((error) => {
          console.error("getStoreDetails fetching failed", error);
          return of(error);
        })
      );
  }
}
